import { IApplicationState } from '../../types/redux';

export function getPromoSearchTypes(state: IApplicationState) {
  return state.filters?.promoSearchTypes;
}
